import { Link } from "react-router-dom";

export default function LegalLayout({ eyebrow, title, lastUpdated, children }) {
  return (
    <>
      <section className="relative border-b border-white/10 bg-obsidian">
        <div className="absolute inset-0 bg-grid opacity-25" />
        <div className="relative max-w-4xl mx-auto px-5 lg:px-8 py-20 lg:py-24">
          <div className="chip text-neon-green">{eyebrow}</div>
          <h1 className="mt-3 font-display font-black text-4xl sm:text-5xl lg:text-6xl text-white tracking-tighter leading-[0.95]">
            {title}
          </h1>
          {lastUpdated && (
            <p className="mt-5 font-mono text-sm text-white/50">
              Last updated: <span className="text-white/70">{lastUpdated}</span>
            </p>
          )}
        </div>
      </section>

      <section className="bg-obsidian">
        <div className="max-w-4xl mx-auto px-5 lg:px-8 py-16 lg:py-24">
          <article className="prose-neon font-mono text-[14px] leading-relaxed text-white/80 space-y-6">
            {children}
          </article>

          <div className="mt-16 border-t border-white/10 pt-8 flex flex-wrap gap-3">
            <Link
              to="/privacy"
              className="border border-white/10 px-4 py-2.5 font-mono text-xs uppercase tracking-widest text-white/70 hover:border-neon-green hover:text-neon-green transition-colors"
            >
              Privacy
            </Link>
            <Link
              to="/terms"
              className="border border-white/10 px-4 py-2.5 font-mono text-xs uppercase tracking-widest text-white/70 hover:border-neon-green hover:text-neon-green transition-colors"
            >
              Terms
            </Link>
            <Link
              to="/refund"
              className="border border-white/10 px-4 py-2.5 font-mono text-xs uppercase tracking-widest text-white/70 hover:border-neon-green hover:text-neon-green transition-colors"
            >
              Refund
            </Link>
            <Link
              to="/cookies"
              className="border border-white/10 px-4 py-2.5 font-mono text-xs uppercase tracking-widest text-white/70 hover:border-neon-green hover:text-neon-green transition-colors"
            >
              Cookies
            </Link>
          </div>
        </div>
      </section>

      <style>{`
        .prose-neon h2 {
          font-family: 'Space Grotesk', sans-serif;
          color: #fff;
          font-size: 22px;
          font-weight: 700;
          margin-top: 32px;
          margin-bottom: 12px;
          letter-spacing: -0.01em;
        }
        .prose-neon h3 {
          font-family: 'Space Grotesk', sans-serif;
          color: #fff;
          font-size: 17px;
          font-weight: 600;
          margin-top: 20px;
          margin-bottom: 8px;
        }
        .prose-neon p { margin: 0 0 12px 0; }
        .prose-neon ul { list-style: none; padding: 0; margin: 0 0 14px 0; }
        .prose-neon ul li { padding-left: 22px; position: relative; margin-bottom: 8px; }
        .prose-neon ul li::before {
          content: '>';
          color: #00FF41;
          position: absolute;
          left: 0;
        }
        .prose-neon a { color: #00FFFF; text-decoration: underline; text-underline-offset: 4px; }
      `}</style>
    </>
  );
}
